import { render, staticRenderFns } from "./HospitalizedInfo.vue?vue&type=template&id=3eda616a&scoped=true&"
import script from "./HospitalizedInfo.vue?vue&type=script&lang=tsx&"
export * from "./HospitalizedInfo.vue?vue&type=script&lang=tsx&"
import style0 from "./HospitalizedInfo.vue?vue&type=style&index=0&id=3eda616a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eda616a",
  null
  
)

export default component.exports